import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import Api from "../../../services/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import swal from "sweetalert";

const image_formats = ["image/jpg", "image/jpeg", "image/png"];

const validationSchema = yup.object().shape({
  legenda: yup.string(),
  imagem: yup
    .mixed()
    .test("required", "Selecione uma imagem", (file) => file && file.length > 0)
    .test("fileSize", "Imagem maior que 2mb.", (file) =>
      file && file.length === 1 ? file[0].size <= 2000000 : true,
    )
    .test("FILE_FORMAT", "Apenas jpg, jpeg e png.", (file) =>
      file && file.length === 1 ? image_formats.includes(file[0].type) : true,
    ),
});

export default function NewFoto({ guiasId, loadFotosGuia, setOpenModalNew }) {
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  const onSubmit = (dataFoto) => {
    setLoading(true);
    const imagefile = document.querySelector("#imagem");

    const bodyFormData = new FormData();
    bodyFormData.append("guias_id", guiasId);
    bodyFormData.append("legenda", dataFoto.legenda || "");
    bodyFormData.append("ordem", dataFoto.ordem || 0);
    bodyFormData.append("imagem", imagefile.files[0]);

    Api.post("/guias/fotos/new", bodyFormData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
          loadFotosGuia();
          setOpenModalNew(false);
        } else {
          swal("Erro!", response.data.message, "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <h2>Nova Foto</h2>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <Grid container className="form">
          <Grid item lg={12} className="field">
            <label>Legenda</label>
            <input type="text" {...register("legenda")} />
          </Grid>
          <Grid item lg={6} className="field">
            <label>Ordem</label>
            <input type="number" defaultValue={0} {...register("ordem")} />
          </Grid>
          <Grid item lg={12} className="field">
            <label>Foto</label>
            <input type="file" name="imagem" id="imagem" {...register("imagem")} />
            <span className="error">{errors.imagem?.message}</span>
          </Grid>
        </Grid>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
          <a href="#" className="cancel" onClick={() => setOpenModalNew(false)}>
            Cancelar
          </a>
        </div>
      </form>
    </>
  );
}
